<template>
  <v-layout align-start>
    <v-flex>
      <v-toolbar
        flat
        color="white"
        v-if="
          itemInfome == 'FOLIOS' ||
            itemInfome == 'BITACORAS' ||
            itemInfome == 'ESTADÍSTICAS ENCUESTAS' ||
            itemInfome == 'ENVIO TRACKING'
        "
      >
        <v-toolbar-title>Informe</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-row align="center" class="mt-5">
          <v-col class="mx-auto" cols="12" md="8">
            <v-select
              v-model="itemInfome"
              :items="selectInformes"
              label="Seleccione..."
              dense
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-text-field
            type="date"
            class="text-xs-center"
            label="Desde"
            hide-details
            v-model="fechaInicio"
            :max="new Date().toISOString().substr(0, 10)"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            type="date"
            class="text-xs-center"
            label="Hasta"
            hide-details
            v-model="fechaFin"
            :max="new Date().toISOString().substr(0, 10)"
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-btn
          @click="listar()"
          color="green"
          v-if="verDet == 0"
          class="mx-auto"
          dark
          >Consultar y descargar</v-btn
        >
      </v-toolbar>
      <!-- Tabla para mostrar todo -->
      <v-data-table
        :headers="headerAll"
        :items="cabinas"
        class="elevation-1"
        v-if="itemInfome == 'TODO' && verNuevo == 0"
        no-data-text="No hay datos"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Informe</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-row align="center" class="mt-5">
              <v-col class="mx-auto" cols="12" md="8">
                <v-select
                  v-model="itemInfome"
                  :items="selectInformes"
                  label="Seleccione..."
                  dense
                  solo
                ></v-select>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <v-col cols="2">
              <v-text-field
                type="date"
                class="text-xs-center"
                label="Desde"
                hide-details
                v-model="fechaInicio"
                :max="new Date().toISOString().substr(0, 10)"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                type="date"
                class="text-xs-center"
                label="Hasta"
                hide-details
                v-model="fechaFin"
                :max="new Date().toISOString().substr(0, 10)"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn
              @click="listar()"
              color="green"
              v-if="verDet == 0"
              class="mx-auto"
              dark
              >Consultar y descargar</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="verDetalles(item)"> tab </v-icon>
        </template>
      </v-data-table>

      <!-- Tabla para encuestas -->
      <v-data-table
        :headers="headerShort"
        :items="cabinas"
        class="elevation-1"
        v-if="itemInfome == 'ENCUESTA' && verNuevo == 0"
        no-data-text="No hay datos"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Informe</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-row align="center" class="mt-5">
              <v-col class="mx-auto" cols="12" md="8">
                <v-select
                  v-model="itemInfome"
                  :items="selectInformes"
                  label="Seleccione..."
                  dense
                  solo
                ></v-select>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <v-col cols="2" class="mt-5 mx-1 pa-1">
              <v-text-field
                type="date"
                class="text-xs-center"
                label="Desde"
                hide-details
                v-model="fechaInicio"
                :max="new Date().toISOString().substr(0, 10)"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="mt-5 mx-1 pa-1">
              <v-text-field
                type="date"
                class="text-xs-center"
                label="Hasta"
                hide-details
                v-model="fechaFin"
                :max="new Date().toISOString().substr(0, 10)"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn
              @click="listar()"
              color="success"
              v-if="verDet == 0"
              class="mx-auto"
              >Consultar y descargar</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="verDetalles(item)"> tab </v-icon>
        </template>
      </v-data-table>

      <!--Formulario para todo -->
      <v-container
        grid-list-sm
        class="pa-4 white"
        v-if="verNuevo && itemInfome == 'TODO'"
      >
        <v-layout row wrap>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="placa" label="Placa"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="polizaBase" label="Poliza"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="marcaBase" label="Marca"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="modeloBase" label="Modelo"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md2 lg2>
            <v-text-field
              type="number"
              v-model="añoBase"
              label="Año"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm2 md2 lg2>
            <v-text-field v-model="usoBase" label="Uso"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="titularPolizaBase"
              label="Ttular Poliza"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm2 md2 lg4 x14>
            <v-autocomplete
              v-model="cartera"
              :items="list_cartera"
              label="Cartera"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4>
            <v-text-field
              v-model="fechaHoraOcurrencia"
              label="Fecha Ocurrencia"
              type="datetime-local"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="numeroTelefono"
              label="Numero Telefono"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="color" label="Color"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg5 x14>
            <v-text-field
              v-model="nombreConductor"
              label="Nombre conductor"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg3 x14>
            <v-autocomplete v-model="pais" :items="list_pais" label="Pais">
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14 class="mb-6 align-self-center">
            <v-autocomplete
              v-model="depaSiniestro"
              :items="list_depaSiniestro"
              label="Departamento Siniestro"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14 class="mb-6 align-self-center">
            <v-autocomplete
              v-model="muniSiniestro"
              :items="list_muniSiniestro"
              label="Municipio Siniestro"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-textarea
              v-model="comDireccionSiniestro"
              label="Complemento Direccion Siniestro"
              auto-grow
              outlined
            ></v-textarea>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-autocomplete v-model="causa" :items="list_causa" label="Causa">
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-autocomplete
              v-model="tipoAsistencia"
              :items="list_tipoAsistencia"
              label="Tipo De Asistencia"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-autocomplete
              v-model="proveedor"
              :items="list_proveedor"
              label="Proveedor"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-autocomplete
              v-model="atiende"
              :items="list_atiende"
              label="Atiende"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="fechaHoraAsignacion"
              label="Fecha Asignacion"
              disabled
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-autocomplete
              v-model="depaOrigen"
              :items="list_depaOrigen"
              label="Departamento Origen"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14 class="mb-6 align-self-center">
            <v-autocomplete
              v-model="muniOrigen"
              :items="list_muniOrigen"
              label="Municipio Origen"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-textarea
              v-model="comDireccionOrigen"
              label="Complemento Direccion Origen"
              auto-grow
              outlined
            ></v-textarea>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14 class="mb-6 align-self-center">
            <v-autocomplete
              v-model="depaDestino"
              :items="list_depaDestino"
              label="Departamento Destino"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14 class="mb-6 align-self-center">
            <v-autocomplete
              v-model="muniDestino"
              :items="list_muniDestino"
              label="Municipio Destino"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-textarea
              v-model="comDireccionDestino"
              label="Complemento Direccion Destino"
              auto-grow
              outlined
            ></v-textarea>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4>
            <v-text-field
              v-model="fechaHoraContacto"
              label="Fecha Contacto"
              type="datetime-local"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              type="number"
              v-model="costoServicio"
              label="Costo Servicio"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3 md3 lg3>
            <v-text-field
              v-model="termino"
              label="Termino"
              step="1"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="placaContraparte"
              label="Placa Contraparte"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-textarea
              v-model="obsAdicionales"
              label="Observaciones Adicionales"
              auto-grow
              outlined
            ></v-textarea>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14 class="mb-6 align-self-center">
            <v-autocomplete
              v-model="tipoServicio"
              :items="list_tipoServicio"
              label="Tipo Servicio"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14 class="mb-6 align-self-center">
            <v-autocomplete
              v-model="estatusAsistencia"
              :items="list_estatusAsistencia"
              item-text="estado"
              item-value="estado"
              label="Estatus Asistencia"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg3>
            <v-text-field v-model="operador" label="Operador" disabled>
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg3>
            <v-text-field
              v-model="numeroSiniestroQualitas"
              label="Numero Siniestro Qualitas"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg3>
            <v-text-field
              v-model="numeroSpoolerQualitas"
              label="Numero Spooler Qualitas"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg3>
            <v-autocomplete
              v-model="localForaneo"
              :items="list_localForaneo"
              label="Local/Foraneo"
            ></v-autocomplete>
          </v-flex>
          <v-row>
            <v-col cols="12" sm="2" md="2">
              <v-checkbox
                v-model="partePolicial"
                label="Hay Parte Policial?"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-checkbox
                v-model="seMovioDelLugar"
                label="Se Movio Del lugar"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-checkbox
                v-model="zonaPeligrosa"
                label="zona Peligrosa"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-checkbox
                v-model="reporteTardio"
                label="Reporte Tardio"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-checkbox
                v-model="roboRecuperado"
                label="Robo Recuperado"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-checkbox
                v-model="recupero"
                label="Recupero Tercero"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-col cols="12" sm="2" md="2" v-if="recupero">
            <v-text-field
              v-model="cantRecupero"
              type="number"
              label="Recupero Tercero"
            ></v-text-field>
          </v-col>
          <v-flex xs12 sm4 md4 lg4>
            <v-text-field
              v-model="fechaHoraCierreAsistencia"
              label="Fecha Cierre Asistencia"
              type="datetime-local"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-btn @click="ocultarNuevo()" color="cancel">Cancelar</v-btn>
          </v-flex>
        </v-layout>
      </v-container>

      <!--Formulario para encuestas -->
      <v-container
        grid-list-sm
        class="pa-4 white"
        v-if="verNuevo && itemInfome == 'ENCUESTA'"
      >
        <v-layout row wrap>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field v-model="placa" label="Placa"></v-text-field>
          </v-flex>
          <v-flex xs12 sm2 md2 lg4 x14>
            <v-autocomplete
              v-model="cartera"
              :items="list_cartera"
              label="Cartera"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4>
            <v-text-field
              v-model="fechaHoraOcurrencia"
              label="Fecha Ocurrencia"
              type="datetime-local"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="numeroTelefono"
              label="Numero Telefono"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-text-field
              v-model="nombreConductor"
              label="Nombre conductor"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-autocomplete
              v-model="tipoAsistencia"
              :items="list_tipoAsistencia"
              label="Tipo De Asistencia"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14>
            <v-autocomplete
              v-model="proveedor"
              :items="list_proveedor"
              label="Proveedor"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 x14 class="mb-6 align-self-center">
            <v-autocomplete
              v-model="estatusAsistencia"
              :items="list_estatusAsistencia"
              item-text="estado"
              item-value="estado"
              label="Estatus Asistencia"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4 md4 lg3>
            <v-text-field v-model="operador" label="Operador" disabled>
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-btn @click="ocultarNuevo()" color="cancel">Cancelar</v-btn>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>

      <v-snackbar v-model="snackValidacion" color="cyan darken-2" right top
        >Los campos de Fecha inicio y Fecha Fin no deben estar
        vacios.</v-snackbar
      >

      <v-btn
        v-scroll="onScroll"
        @click="toTop"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        right
        color="red"
        v-if="verNuevo == 1"
        class="mb-10"
      >
        <i class="fas fa-chevron-up"></i>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";
import settings from "../settings/index";
export default {
  data() {
    return {
      cabinas: [],
      bitacoras: [],
      headerAll: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Nmero Asistencia",
          value: "numeroAsistencia",
          align: "left",
          sortable: true,
        },
        {
          text: "Estado",
          align: "left",
          value: "estatusAsistencia",
          sortable: true,
        },
        {
          text: "Fecha Actual",
          value: "fechaHoraActual",
          align: "left",
          sortable: true,
        },
        {
          text: "Proveedor",
          value: "proveedor",
          align: "left",
          sortable: true,
        },
        {
          text: "Tipo Asistencia",
          value: "tipoAsistencia",
          align: "left",
          sortable: true,
        },
        { text: "Numero Telefono", value: "numeroTelefono", sortable: true },
        { text: "Placa", value: "placa", align: "left", sortable: true },
        { text: "Poliza", value: "polizaBase", align: "left", sortable: true },
        { text: "Marca", value: "marcaBase", align: "left", sortable: true },
        { text: "Modelo", value: "modeloBase", align: "left", sortable: true },
        { text: "Año", value: "añoBase", align: "left", sortable: true },
        {
          text: "Titular Poliza",
          value: "titularPolizaBase",
          align: "left",
          sortable: true,
        },
      ],
      headerShort: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Nmero Asistencia",
          value: "numeroAsistencia",
          align: "left",
          sortable: true,
        },
        {
          text: "Estado",
          align: "left",
          value: "estatusAsistencia",
          sortable: true,
        },
        {
          text: "Fecha Actual",
          value: "fechaHoraActual",
          align: "left",
          sortable: true,
        },
        {
          text: "Proveedor",
          value: "proveedor",
          align: "left",
          sortable: true,
        },
        {
          text: "Tipo Asistencia",
          value: "tipoAsistencia",
          align: "left",
          sortable: true,
        },
        { text: "Numero Telefono", value: "numeroTelefono", sortable: true },
        { text: "Placa", value: "placa", align: "left", sortable: true },
      ],
      id: "",
      idBase: "",
      fechaHoraActual: "",
      cartera: "",
      list_cartera: [],
      fechaHoraOcurrencia: "",
      numeroAsistencia: "",
      numeroTelefono: "",
      placa: "",
      polizaBase: "",
      marcaBase: "",
      modeloBase: "",
      añoBase: 0,
      usoBase: "",
      titularPolizaBase: "",
      estatusBase: "",
      color: "",
      nombreConductor: "",
      pais: "",
      list_pais: settings.list_pais,
      depaSiniestro: "",
      list_depaSiniestro: settings.list_depaSiniestro,
      muniSiniestro: "",
      list_muniSiniestro: settings.list_muniSiniestro,
      comDireccionSiniestro: "",
      causa: "",
      list_causa: settings.list_causa,
      tipoServicio: "",
      list_tipoServicio: settings.list_tipoServicio,
      proveedor: "",
      list_proveedor: settings.list_proveedor,
      atiende: "",
      list_atiende: settings.list_atiende,
      fechaHoraAsignacion: "",
      depaOrigen: "",
      list_depaOrigen: settings.list_depaOrigen,
      muniOrigen: "",
      list_muniOrigen: settings.list_muniOrigen,
      comDireccionOrigen: "",
      depaDestino: "",
      list_depaDestino: settings.list_depaDestino,
      muniDestino: "",
      list_muniDestino: settings.list_muniDestino,
      comDireccionDestino: "",
      fechaHoraContacto: "",
      costoServicio: "",
      fechaHoraCierreAsistencia: "",
      placaContraparte: "",
      partePolicial: false,
      obsAdicionales: "",
      tipoAsistencia: "",
      list_tipoAsistencia: [],
      numeroSiniestroQualitas: "",
      numeroSpoolerQualitas: "",
      seMovioDelLugar: false,
      zonaPeligrosa: false,
      reporteTardio: false,
      roboRecuperado: false,
      localForaneo: "",
      list_localForaneo: settings.list_localForaneo,
      operador: "",
      estatusAsistencia: "EN PROCESO",
      list_estatusAsistencia: [],
      verNuevo: 0,
      verDet: 0,
      resumenBitacora: [],
      fab: false,
      fechaInicio: "",
      fechaFin: "",
      recupero: false,
      cantRecupero: "",
      termino: "",
      overlay: false,
      snackValidacion: false,
      selectInformes: [
        "TODO",
        "ENCUESTA",
        "FOLIOS",
        "BITACORAS",
        "ESTADÍSTICAS ENCUESTAS",
        "ENVIO TRACKING",
      ],
      itemInfome: "TODO",
      items_folios: [],
      interval: "",
    };
  },
  created() {
    this.listarComboBox();
    this.listarTipoAsistencias();
  },
  methods: {
    listarTipoAsistencias() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/TipoAsistencias/Activas", configuracion)
        .then((res) => (this.list_tipoAsistencia = res.data))
        .catch((err) => console.error(err.response));
    },
    listarComboBox() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Carteras/Activas", configuracion)
        .then((res) => (this.list_cartera = res.data))
        .catch((err) => console.error(err.response));

      axios
        .get("api/EstadosAsistencia", configuracion)
        .then((res) => (this.list_estatusAsistencia = res.data))
        .catch((err) => console.error(err));
    },
    mostrarNuevo() {
      let me = this;
      this.operador = me.$store.state.usuario.nombre;
      this.verNuevo = 1;
    },
    ocultarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },
    exportExcel(info, fileName = "Informe", workbookName = "Libro") {
      const data = XLSX.utils.json_to_sheet(info);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, data, workbookName);

      const filename = `${fileName} ${this.fechaInicio} a ${this.fechaFin}.xlsx`;
      XLSX.writeFile(workbook, filename);
    },
    listar() {
      if (this.fechaInicio != "" && this.fechaFin != "") {
        this.overlay = true;
        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };
        let url = "";
        if (this.itemInfome === "TODO") {
          url =
            "api/Cabinas/InformeTODO/" + this.fechaInicio + "/" + this.fechaFin;
        }
        if (this.itemInfome === "ENCUESTA") {
          url = "api/Cabinas/Informe/" + this.fechaInicio + "/" + this.fechaFin;
        }
        if (this.itemInfome === "FOLIOS") {
          url =
            "api/Cabinas/InformeFolios/" +
            this.fechaInicio +
            "/" +
            this.fechaFin;
        }
        if (this.itemInfome == "BITACORAS") {
          url = `api/DetalleBitacora/Reporte?inicio=${this.fechaInicio}&fin=${this.fechaFin}`;
        }

        if (this.itemInfome == "ESTADÍSTICAS ENCUESTAS") {
          url = `api/Cabinas/InformeEstadisticasEncuestas?inicio=${this.fechaInicio}&fin=${this.fechaFin}`;
        }

        if (this.itemInfome == "ENVIO TRACKING") {
          url = `api/Informes/EnviosTracking?inicio=${this.fechaInicio}&fin=${this.fechaFin}`;
        }

        axios
          .get(url, configuracion)
          .then((response) => {
            this.cabinas = response.data;

            if (this.itemInfome == "ENVIO TRACKING") {
              this.exportExcel(response.data, "Tracking AR", "Tracking AR");
              return;
            }

            if (this.itemInfome == "BITACORAS") {
              this.resumenBitacora = response.data;
              this.downloadResumenBitacora();
              return;
            }

            if (this.itemInfome === "FOLIOS") {
              this.ExportarExcelFolios(response.data);
              return;
            }
            this.ExportarExcel();
          })
          .catch((error) => {
            console.error(error.response);
          })
          .finally(() => (this.overlay = false));
      } else {
        this.snackValidacion = true;
      }
    },
    downloadResumenBitacora() {
      const listado = [];

      const formatData = this.resumenBitacora.map((operador) => ({
        Usuario: operador.operador,
        Asistencias: operador.asistencias,
        Total: operador.totalSeguimientos,
      }));

      formatData.forEach((usuario) => {
        if (usuario.Asistencias.length > 0) {
          usuario.Asistencias.forEach((asistencia, index) => {
            listado.push({
              Usuario: index == 0 ? usuario.Usuario : "",
              NumeroAsistencia: asistencia.numeroAsistencia,
              Seguimientos: asistencia.seguimientos,
              SeguimientosCliente: asistencia.seguimientosCliente,
              SeguimientosProveedor: asistencia.seguimientosProveedor,
              Total: index == 0 ? usuario.Total : "",
            });
          });
        } else {
          listado.push({
            Usuario: usuario.Usuario,
            NumeroAsistencia: "----",
            Seguimientos: 0,
            SeguimientosCliente: 0,
            SeguimientosProveedor: 0,
            Total: usuario.Total,
          });
        }

        listado.push({
          Usuario: "",
          NumeroAsistencia: "",
          Seguimientos: "",
          SeguimientosCliente: "",
          SeguimientosProveedor: "",
          Total: "",
        });
      });

      const data = XLSX.utils.json_to_sheet(listado);
      const workbook = XLSX.utils.book_new();

      data["!cols"] = [
        { wch: 30 },
        { wch: 17 },
        { wch: 12 },
        { wch: 15 },
        { wch: 15 },
        { wch: 5 },
      ];

      XLSX.utils.book_append_sheet(workbook, data, "Resumen");

      const filename = `ResumenBitacoras ${this.fechaInicio} a ${this.fechaFin}.xlsx`;
      XLSX.writeFile(workbook, filename);
    },
    filtrarFolios() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      var cont = 0;
      axios
        .get(
          "api/PagoProveedores/ListarPorNumAsistencia/" +
            element.numeroAsistencia,
          configuracion,
        )
        .then((response) => {
          console.log(response.data);
        });

      /*this.cabinas.forEach(async(element) => {
          await axios
            .get(
              "api/PagoProveedores/ListarPorNumAsistencia/" +
                element.numeroAsistencia
            )
            .then((response) => {      
              console.log(response.data);        
              cont++;
              if (response.data.length > 0) {
                this.items_folios.push({
                  numeroFolio: response.data[0].numeroFolio,
                  numeroAsistencia: element.numeroAsistencia,
                  fechaAsistencia: element.fechaHoraActual,
                  proveedor: element.proveedor,
                });
              } else {
                this.items_folios.push({
                  numeroFolio: "",
                  numeroAsistencia: element.numeroAsistencia,
                  fechaAsistencia: element.fechaHoraActual,
                  proveedor: element.proveedor,
                });
              }
              if (cont == this.cabinas.length) {
                this.overlay = false;
                this.ExportarExcelFolios();
              }
            });
      });*/
    },
    verDetalles(item) {
      this.limpiar();
      this.id = item.idCabina;
      this.idBase = item.idBase;
      this.idUsuario = item.idUsuario;
      this.fechaHoraActual = item.fechaHoraActual;
      this.numeroAsistencia = item.numeroAsistencia;
      this.cartera = item.cartera;
      this.fechaHoraOcurrencia = item.fechaHoraOcurrencia;
      this.numeroTelefono = item.numeroTelefono;
      this.placa = item.placa;
      this.polizaBase = item.polizaBase;
      this.marcaBase = item.marcaBase;
      this.modeloBase = item.modeloBase;
      this.añoBase = item.añoBase;
      this.usoBase = item.usoBase;
      this.titularPolizaBase = item.titularPolizaBase;
      this.color = item.color;
      this.nombreConductor = item.nombreConductor;
      this.pais = item.pais;
      this.depaSiniestro = item.depaSiniestro;
      this.list_muniSiniestro[0] = item.muniSiniestro;
      this.muniSiniestro = this.list_muniSiniestro[0];
      this.comDireccionSiniestro = item.comDireccionSiniestro;
      this.causa = item.causa;
      this.tipoServicio = item.tipoServicio;
      this.proveedor = item.proveedor;
      this.atiende = item.atiende;
      this.fechaHoraAsignacion = item.fechaHoraAsignacion;
      this.depaOrigen = item.depaOrigen;
      this.list_muniOrigen[0] = item.muniOrigen;
      this.muniOrigen = this.list_muniOrigen[0];
      this.comDireccionOrigen = item.comDireccionOrigen;
      this.depaDestino = item.depaDestino;
      this.list_muniDestino[0] = item.muniDestino;
      this.muniDestino = this.list_muniDestino[0];
      this.comDireccionDestino = item.comDireccionDestino;
      this.fechaHoraContacto = item.fechaHoraContacto;
      this.costoServicio = item.costoServicio;
      this.fechaHoraCierreAsistencia = item.fechaHoraCierreAsistencia;
      this.placaContraparte = item.placaContraparte;
      this.partePolicial = item.partePolicial;
      this.obsAdicionales = item.obsAdicionales;
      this.tipoAsistencia = item.tipoAsistencia;
      this.operador = item.operador;
      this.numeroSiniestroQualitas = item.numeroSiniestroQualitas;
      this.numeroSpoolerQualitas = item.numeroSpoolerQualitas;
      this.seMovioDelLugar = item.seMovioDelLugar;
      this.zonaPeligrosa = item.zonaPeligrosa;
      this.reporteTardio = item.reporteTardio;
      this.estatusAsistencia = item.estatusAsistencia;
      this.roboRecuperado = item.roboRecuperado;
      this.localForaneo = item.localForaneo;
      this.cantRecupero = item.cantRecupero;
      this.termino = item.termino;
      this.verDet = 1;
      this.verNuevo = 1;
      //verificar si en el campo cantRecupero hay digito
      this.verificarRecupero();
    },
    limpiar() {
      this.id = "";
      this.idBase = "";
      this.idUsuario = "";
      this.numeroAsistencia = "";
      this.cartera = "";
      this.fechaHoraOcurrencia = "";
      this.numeroTelefono = "";
      this.placa = "";
      this.polizaBase = "";
      this.modeloBase = "";
      this.marcaBase = "";
      this.añoBase = 0;
      this.usoBase = "";
      this.titularPolizaBase = "";
      (this.condicion = ""), (this.color = "");
      this.nombreConductor = "";
      this.asegurado = "";
      this.pais = "";
      this.depaSiniestro = "";
      this.muniSiniestro = "";
      this.comDireccionSiniestro = "";
      this.causa = "";
      this.tipoServicio = "";
      this.proveedor = "";
      this.atiende = "";
      this.fechaHoraAsignacion = "";
      this.depaOrigen = "";
      this.muniOrigen = "";
      this.comDireccionOrigen = "";
      this.depaDestino = "";
      this.muniDestino = "";
      this.comDireccionDestino = "";
      this.fechaHoraContacto = "";
      this.costoServicio = "";
      this.fechaHoraCierreAsistencia = "";
      this.placaContraparte = "";
      this.partePolicial = false;
      this.obsAdicionales = "";
      this.tipoAsistencia = "";
      this.numeroSiniestroQualitas = "";
      this.numeroSpoolerQualitas = "";
      this.seMovioDelLugar = false;
      this.zonaPeligrosa = false;
      this.reporteTardio = false;
      this.roboRecuperado = false;
      (this.localForaneo = ""), (this.operador = "");
      this.estatusAsistencia = "EN PROCESO";
      this.recupero = false;
      this.termino = "";
      this.cantRecupero = "";
      this.verDet = 0;
      this.bitacoras = [];
    },
    ExportarExcelFolios(obj = []) {
      let data = XLSX.utils.json_to_sheet(obj);
      const workbook = XLSX.utils.book_new();
      const filename = "Folios";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    ExportarExcel() {
      let data = XLSX.utils.json_to_sheet(this.cabinas);
      const workbook = XLSX.utils.book_new();
      const filename = "Base " + this.fechaInicio + " " + this.fechaFin;
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    verificarRecupero() {
      if (this.cantRecupero != null) {
        //si es campo no esta vacio el checkbox se marcara y mostrara el campo
        this.recupero = true;
      }
    },
  },
};
</script>
